import React from 'react'
import { Row, Col, Form, Pagination } from 'react-bootstrap'

export interface PaginationTableFooterProps {
  onPageSizeChanged: (pageSize: number) => void
  onPrevClicked: () => void
  onNextClicked: () => void
  isLoading: boolean
}

const PaginationTableFooter: React.FC<PaginationTableFooterProps> = ({
  onPageSizeChanged,
  onPrevClicked,
  onNextClicked,
  isLoading
}) => {
  return (
    <div data-testid="paginationFC" className="styledPagination">
      <Row>
        <Col xs="auto">
          <Form.Control
            as="select"
            onChange={e => onPageSizeChanged(Number(e.currentTarget.value))}
            disabled={isLoading}
            data-testid="pageSizeSelect"
          >
            <option>10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </Form.Control>
        </Col>
        <Col></Col>
        <Col xs="auto">
          <Pagination>
            <Pagination.Prev
              onClick={onPrevClicked}
              disabled={isLoading}
              data-testid="prevPageButton"
            >
              &laquo; Previous
            </Pagination.Prev>
            <Pagination.Next
              onClick={onNextClicked}
              disabled={isLoading}
              data-testid="nextPageButton"
            >
              Next &raquo;
            </Pagination.Next>
          </Pagination>
        </Col>
      </Row>
    </div>
  )
}

export default PaginationTableFooter
